import { Box, Flex } from "@chakra-ui/layout";
import { PromocodeCoupon } from "components/SvgIcons/icons/promocodeCoupon";
import React from "react";
import { colours } from "@shared/ui.design-system";

import type { ItemDiscounts } from "../hooks/useGetDiscountsByType";
import { OrderSections } from "../OrderSections";
import { Label } from "../OrderSections/OrderSections.styles";

type Props = {
  discounts: ItemDiscounts[];
};

const PromocodeList = ({ codes }: { codes: string[] }) => {
  return (
    <Flex flexDirection="row" flexWrap="wrap">
      Promo Code
      {codes.map((code) => (
        <>
          <Box ml="-1">
            <PromocodeCoupon /> {code}
          </Box>
        </>
      ))}
    </Flex>
  );
};

export const DiscountsCode: React.FC<Props> = ({ discounts }) => {
  return (
    <>
      {discounts.map((disc) => {
        return (
          <OrderSections
            key={disc.name}
            section={{
              testId: "discountTotal",
              label: (
                <Label variant="acuminLight">
                  {disc.codes ? (
                    <PromocodeList codes={disc.codes} />
                  ) : (
                    "Discount"
                  )}
                </Label>
              ),
              color: colours.primary.dark,
              variant: "acuminLight",
              price: disc.value,
              hasLine: false,
              isDiscount: true
            }}
          />
        );
      })}
    </>
  );
};
